import { motion, useMotionTemplate, useMotionValue, useSpring, useTransform } from "framer-motion";

function Tilt3DInner({ children, className = "", max = 10, glare = true, scale = 1.02, style, ...rest }) {
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const rotateX = useSpring(useTransform(my, [0, 1], [max, -max]), { stiffness: 150, damping: 18 });
  const rotateY = useSpring(useTransform(mx, [0, 1], [-max, max]), { stiffness: 150, damping: 18 });
  const gx = useTransform(mx, (v) => `${v * 100}%`);
  const gy = useTransform(my, (v) => `${v * 100}%`);
  const glareBg = useMotionTemplate`radial-gradient(circle at ${gx} ${gy}, rgba(255,255,255,0.45), rgba(255,255,255,0) 55%)`;

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width);
    my.set((e.clientY - r.top) / r.height);
  };
  const onLeave = () => {
    mx.set(0.5);
    my.set(0.5);
  };

  return (
    <motion.div
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      whileHover={{ scale }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      style={{ rotateX, rotateY, transformPerspective: 1100, transformStyle: "preserve-3d", ...style }}
      className={`group relative shadow-[0_24px_60px_-20px_rgba(14,13,11,0.35)] will-change-transform ${className}`}
      {...rest}
    >
      {children}
      {glare && (
        <motion.div
          aria-hidden="true"
          style={{ background: glareBg }}
          className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 mix-blend-soft-light"
        />
      )}
    </motion.div>
  );
}

export default function Tilt3D({ light = false, className = "", style, children, ...rest }) {
  if (light) {
    return (
      <div style={style} className={`relative shadow-[0_24px_60px_-20px_rgba(14,13,11,0.35)] ${className}`} {...rest}>
        {children}
      </div>
    );
  }
  return (
    <Tilt3DInner className={className} style={style} {...rest}>
      {children}
    </Tilt3DInner>
  );
}
